import { ModelSagres } from "../../model-sagres";
import { Banca } from "./banca";
import { TipoEdital } from "./tipo-edital";

export class EditalConcurso extends ModelSagres {
  IdEdital: number;
  IdTipoEdital: number | null;
  IdBanca: number | null;
  IdSituacao: number;
  NrEdital: number;
  AnoEdital: number;
  Validade: number;
  Prorrogacao: number;
  DispensaLicitacao: boolean;
  CodUgSagres: string;
  DtPublicacao: Date;
  DtProva?: Date;
  DtProvaFinal?: Date;
  DtInicioInscricao: Date;
  DtFimInscricao: Date;
  DtHomologacao?: Date;
  DtExclusao?: Date;
  CpfUsuario: string;
  NrCadastroLW: number;
  DtCriacao?: Date;
  DtAlteracao?: Date;
  FlAtivo?: boolean;
  FlProrrogado?: boolean;
  IdBancaNavigation: Banca;
  IdTipoEditalNavigation: TipoEdital;
  DtValidade: Date;
  DtCancelamento: Date;
  FlPermiteProrrogacao: boolean
  IdLicitacao: number | null
  DsDotacaoOrcamentaria: string
  DsAutorizacaoLDO: string
  FlProvaOral: boolean
  FlExamePsicotecnico: boolean
  DsProvaOral: string
  DsExamePsicotecnico: string
  FlTempoExperienciaLei: boolean
  FlDevolucaoTaxaInscricao: boolean
  FlIsencao: boolean
  FlInscricaoEstrangeiros: boolean
  FlCritDesempateEstatutoIdoso: boolean
  FlRecursosTodasFases: boolean
  FlPublicacaoTodasFases: boolean
  CodLicitacaoIgesp: string | null
  FlVagasPcd: boolean
  DsVagasPcd: string
  FlVagasCotas: boolean
  DsVagasCotas: string
  FlTaf: boolean
  DsTaf: string
  DsTempoExperienciaLei: string
  constructor(obj?: any) {
    super();
    if (obj) {
      this.IdEdital = obj.IdEdital;
      this.IdTipoEdital = obj.IdTipoEdital;
      this.IdBanca = obj.IdBanca;
      this.IdSituacao = obj.IdSituacao;
      this.NrEdital = obj.NrEdital;
      this.AnoEdital = obj.AnoEdital;
      this.Prorrogacao = obj.Prorrogacao;
      this.Validade = obj.Validade;
      this.DispensaLicitacao = obj.DispensaLicitacao;
      this.CodUgSagres = obj.CodUgResponsavel ?? obj.CodUgSagres;
      this.DtPublicacao = obj.DtPublicacao;
      this.DtProva = obj.DtProva;
      this.DtProvaFinal = obj.DtProvaFinal;
      this.DtInicioInscricao = obj.DtInicioInscricao;
      this.DtFimInscricao = obj.DtFimInscricao;
      this.DtHomologacao = obj.DtHomologacao;
      this.CpfUsuario = obj.CpfUsuario;
      this.NrCadastroLW = obj.NrCadastroLW
      this.DtCriacao = obj.DtCriacao;
      this.DtAlteracao = obj.DtAlteracao;
      this.FlAtivo = obj.FlAtivo;
      this.FlProrrogado = obj.FlProrrogado;
      this.IdBancaNavigation = obj.IdBancaNavigation;
      this.IdTipoEditalNavigation = obj.IdTipoEditalNavigation;
      this.DtValidade = obj.DtValidade;
      this.DtCancelamento = obj.DtCancelamento;
      this.FlPermiteProrrogacao = obj.FlPermiteProrrogacao;
      this.IdLicitacao = obj.IdLicitacao;
      this.DsDotacaoOrcamentaria = obj.DsDotacaoOrcamentaria;
      this.DsAutorizacaoLDO = obj.DsAutorizacaoLDO;
      this.FlProvaOral = obj.FlProvaOral;
      this.FlExamePsicotecnico = obj.FlExamePsicotecnico;
      this.DsProvaOral = obj.DsProvaOral;
      this.DsExamePsicotecnico = obj.DsExamePsicotecnico;
      this.FlTempoExperienciaLei = obj.FlTempoExperienciaLei;
      this.FlDevolucaoTaxaInscricao = obj.FlDevolucaoTaxaInscricao;
      this.FlIsencao = obj.FlIsencao;
      this.FlInscricaoEstrangeiros = obj.FlInscricaoEstrangeiros;
      this.FlCritDesempateEstatutoIdoso = obj.FlCritDesempateEstatutoIdoso;
      this.FlRecursosTodasFases = obj.FlRecursosTodasFases;
      this.FlPublicacaoTodasFases = obj.FlPublicacaoTodasFases;
      this.CodLicitacaoIgesp = obj.CodLicitacaoIgesp;
      this.FlVagasPcd = obj.FlVagasPcd;
      this.DsVagasPcd = obj.DsVagasPcd;
      this.FlVagasCotas = obj.FlVagasCotas;
      this.DsVagasCotas = obj.DsVagasCotas;
      this.FlTaf = obj.FlTaf;
      this.DsTaf = obj.DsTaf;
      this.DsTempoExperienciaLei = obj.DsTempoExperienciaLei;
    }
  }
}
